import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { StyledTreeItem, StyledTreeView } from './Tree.styles';

const Tree = ({ data }) => {
  const renderTree = (nodes) => (
    <StyledTreeItem
      haschildren={Array.isArray(nodes.children).toString()}
      key={nodes.id}
      nodeId={`${nodes.id}`}
      label={
        <p>
          <span>{`${nodes.key}`} </span>
          {`${nodes.value}`}
        </p>
      }
    >
      {Array.isArray(nodes.children) ? nodes.children.map((node) => renderTree(node)) : null}
    </StyledTreeItem>
  );

  return (
    <StyledTreeView
      disableSelection
      aria-label="rich object"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      sx={{ width: 'auto', height: 'auto', flexGrow: 1, maxWidth: 800, maxHeight: 600, overflowY: 'auto' }}
    >
      {renderTree(data)}
    </StyledTreeView>
  );
};

export default Tree;
